<template>
    <!-- transition -->
    <transition name="popup">

        <!-- Modal mask -->
        <div class="popup-mask" ref="popup">

            <!-- modal content wrapper -->
            <div class="popup-content-wrapper">
                <div @click="$emit('input', false)" class="popup-close">
                    <img src="../assets/images/times.png" alt="times">
                </div>
                <slot></slot>
            </div>
            <!-- modal content wrapper -->

        </div>
        <!-- Modal mask -->

    </transition>
    <!-- transition -->
</template>

<script>
export default {}
</script>

<style scoped>
/* - Modal mask - */
.popup-mask {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    background-color: var(--orma-transperent);
    transition: opacity 0.3s ease;
}

/* modal content wrapper */
.popup-content-wrapper {
    will-change: opacity, transform;
    transition: all 0.3s ease;
    position: relative;
}

/* modal open/close animation */
.popup-enter {
    opacity: 0;
}

.popup-enter .popup-content-wrapper {
    transform: translateY(30px);
}

.popup-leave-active {
    opacity: 0;
}

.popup-leave-active .popup-content-wrapper {
    transform: translateY(-30px);
}

.popup-close {
    border: 1px solid #000000;
    width: 25px;
    height: 25px;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.popup-close img {
    width: 28px;
    filter: brightness(0%);
}


@media screen and (max-width: 630px) {
    .popup-content-wrapper {
        height: 100%;
        width: 100%;
    }
}
</style>